import * as locales from 'date-fns/locale';
import { formatInTimeZone } from 'date-fns-tz';

export function formatInTimeZoneWithLocale(dateTime: string, format: string, TZ: string, locale: string) {
  return formatInTimeZone(dateTime, TZ, format, {
    locale: locales[locale.replace('-', '') as keyof typeof locales] ?? locales.enUS,
  });
}
